import { useEffect, useRef } from "react";

export const useHandleOnboarding = ({
  validatedEmail,
  updateValidatedEmail,
}: {
  validatedEmail: string;
  updateValidatedEmail: (email: string, options: { ssoRedirectPath?: string }) => Promise<void>;
}) => {
  const searchParams = new URLSearchParams(window.location.search);
  const onboardingEmail = searchParams.get("email");

  const hasRun = useRef(false);

  useEffect(() => {
    if (hasRun.current) {
      return;
    }
    hasRun.current = true;

    if (onboardingEmail) {
      // this allows a user to re-use the sso invitation link
      // without seeing the onboarding page every time
      // Could be removed if we store the accept t&c value
      const ssoRedirectPath = validatedEmail ? undefined : "/onboarding";
      void updateValidatedEmail(onboardingEmail, { ssoRedirectPath });
    }
  }, [validatedEmail, onboardingEmail, updateValidatedEmail]);
};
